"use strict";

require("lazysizes/plugins/respimg/ls.respimg.js");
require("lazysizes");
var _objectFitImages = _interopRequireDefault(require("object-fit-images"));
require("./js/header");
require("./js/play-button");
require("./js/accordion");
require("./js/searchpage");
require("./js/carousel");
require("./js/unsupported-browser");
require("./js/lazy-hack");
require("./js/vacancy-modal");
require("./js/alert-banner");
var _pdfjsDist = require("pdfjs-dist");
var _pdfWorker = _interopRequireDefault(require("pdfjs-dist/build/pdf.worker.js"));
var _pageFlip = require("page-flip");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
(0, _objectFitImages.default)(null, {
  watchMQ: true
});
if (document.querySelector('.menu-anchor')) {
  Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./parts/menu-anchor/index'));
  });
}
window.PdfjsLib = {
  getDocument: _pdfjsDist.getDocument,
  GlobalWorkerOptions: _pdfjsDist.GlobalWorkerOptions,
  workerSrc: _pdfWorker.default
};
window.PageFlip = _pageFlip.PageFlip;